import React, { useState, useEffect } from "react";
import "./ChatDrawer.css";
import MahalAI from "../../images/mahalai5.png";

const ChatDrawer = ({ onClose, mode = "documentation" }) => {

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [messages, setMessages] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {

    if (mode === "documentation") {

      setMessages([
        {
          sender: "assistant",
          text: "👋 Hi!\n\nI'm Mahal AI.\n\nHow can I help you today?"
        }
      ]);

    } else {

      setMessages([
        {
          sender: "assistant",
          text: "👋 Hi!\n\nI'm Mahal AI.\n\nLooking for products today?"
        }
      ]);

      // loadPromotions();

    }

  }, [mode]);

  const documentationSuggestions = [
    "How do I create a supplier account?",
    "How do I register my restaurant?",
    "How do I add a menu?"
  ];

  const shoppingSuggestions = [
    "Show rice",
    "Show cooking oil",
    "Show today's offers"
  ];

  const suggestions =
    mode === "shopping"
      ? shoppingSuggestions
      : documentationSuggestions;

  const loadPromotions = async () => {

    try {

      const res = await fetch(
        "http://127.0.0.1:5000/api/promotions"
      );

      const data = await res.json();

      if (data.success) {
        setProducts(data.products);
      }

    } catch (e) {
      console.log(e);
    }

  };

  const sendMessage = async (question = null) => {

    const userMessage =
      typeof question === "string"
        ? question
        : message;

    if (!userMessage.trim()) return;

    setMessages(prev => [
      ...prev,
      {
        sender: "user",
        text: userMessage
      }
    ]);

    setMessage("");

    setLoading(true);

    try {

      const response = await fetch(
        "http://127.0.0.1:5000/api/chat",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            mode,
            message: userMessage
          })
        }
      );

      const data = await response.json();

      if (data.type === "documentation") {

        setMessages(prev => [
          ...prev,
          {
            sender: "assistant",
            text: data.response
          }
        ]);

      }

      else if (data.type === "shopping") {

        setProducts(data.products || []);

        setMessages(prev => [
          ...prev,
          {
            sender: "assistant",
            text: `I found ${data.products.length} product(s).`
          }
        ]);

      }

      else if (data.type === "promotions") {

        setProducts(data.products || []);

        setMessages(prev => [
          ...prev,
          {
            sender: "assistant",
            text: "Here are today's promotions."
          }
        ]);

      }

    }

    catch {

      setMessages(prev => [
        ...prev,
        {
          sender: "assistant",
          text: "⚠ Unable to connect to Mahal AI."
        }
      ]);

    }

    finally {

      setLoading(false);

    }

  };

  return (

    <div className="chat_overlay">

      <div className="chat_drawer">

        <div className="aichat_header">

          <h4 className="aichat_title">

            <img
              src={MahalAI}
              alt="Mahal AI"
              className="mahal_ai_icon"
            />

            <span className="title_text">
              Mahal AI
            </span>

          </h4>

          <button onClick={onClose}>
            ✕
          </button>

        </div>

        <div className="chat_body">

          {messages.map((msg, index) => (

            <div
              key={index}
              className={
                msg.sender === "user"
                  ? "user_message"
                  : "assistant_message"
              }
            >
              {msg.text}
            </div>

          ))}

          {mode === "shopping" && products.length > 0 && (

            <div className="shopping_products">

              {products.map(product => (

                <div
                  key={product.product_id}
                  className="shopping_card"
                >

                  <img
                    src={product.image_url}
                    alt={product.product_name_english}
                  />

                  <h5>
                    {product.product_name_english}
                  </h5>

                  <p>
                    QAR {product.price_per_unit}
                  </p>

                </div>

              ))}

            </div>

          )}

          {messages.length === 1 && (

            <div className="suggestions">

              <h5>Try asking</h5>

              {suggestions.map((question, index) => (

                <button
                  key={index}
                  className="suggestion_btn"
                  onClick={() => sendMessage(question)}
                >
                  {question}
                </button>

              ))}

            </div>

          )}

          {loading && (

            <div className="assistant_message">
              Mahal AI is thinking...
            </div>

          )}

        </div>

        <div className="chat_footer">

          <input
            type="text"
            placeholder="Ask Mahal AI..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                sendMessage();
              }
            }}
          />

          <button
            onClick={sendMessage}
            disabled={loading}
          >
            {loading ? "..." : "Send"}
          </button>

        </div>

      </div>

    </div>

  );

};

export default ChatDrawer;